import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "message-area" }
const _hoisted_2 = { style: {"text-align":"center"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dialog_frame = _resolveComponent("dialog-frame")!

  return (_ctx.isDisplay)
    ? (_openBlock(), _createBlock(_component_dialog_frame, { key: 0 }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "alertTop",
            style: _normalizeStyle(_ctx.borderStyles)
          }, [
            _createElementVNode("div", {
              class: "close-button-position-absolute",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeDialog && _ctx.closeDialog(...args)))
            }, "x"),
            _createElementVNode("div", _hoisted_1, [
              _renderSlot(_ctx.$slots, "default", {}, undefined, true)
            ]),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("button", {
                class: "btn btn-primary",
                style: {"min-width":"6rem"},
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.execute && _ctx.execute(...args)))
              }, _toDisplayString(_ctx.okButton), 1)
            ])
          ], 4)
        ]),
        _: 3
      }))
    : _createCommentVNode("", true)
}